import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit,
  ViewChild
} from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { NotificationsService } from "angular2-notifications";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { merge } from "rxjs/internal/observable/merge";
import { filter } from "rxjs/operators";
import { UserService } from "../../../shared/services/user/user.service";
import { AlertContentInterface } from "../interfaces/alert-content.interface";
import { Notification } from "../interfaces/notification-base.interface";
import { NotificationsSystemBase } from "../models/notifications-system-base.model";
import { AlertsNotificationsService } from "../services/alerts-notifications.service";

import { NotificationMenuService } from "../services/notification-menu.service";
import { NotificationSystemsRegistryService } from "../services/notification-systems-registry.service";
import { MatTabGroup } from "@angular/material/tabs";
import { Router } from "@angular/router";
import { DocumentRequestNotificationsService } from "../services/document-request-notification.service";
import { NodesService } from "src/app/+home/+my-libraries/+sites/document-library/shared/services/nodes.service";
import { SITE_NAME } from "src/environments/environment";
import { WorkflowNotificationService } from "../services/workflow-notification.service";
import { WorkflowContentInterface } from "../interfaces/workflow-content.interface";

class NotificationBadge {
  constructor(public notificationsStreamObservable: Observable<any>) {
    notificationsStreamObservable.subscribe(() => {
      this.counter++;
    });
  }

  private _counter = new BehaviorSubject<number>(0);

  get counter(): number {
    return this._counter.value;
  }

  set counter(value: number) {
    this._counter.next(value);
  }

  reset() {
    this.counter = 0;
  }
}

interface NotificationsTabInterface {
  header: string;

  notifications: Notification[];

  service: NotificationsSystemBase;

  badge: NotificationBadge;
}

@Component({
  selector: "app-notification-menu",
  styleUrls: ["./notification-menu.component.scss"],
  templateUrl: "./notification-menu.component.html"
})
export class NotificationMenuComponent implements OnInit, AfterViewInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  alertsNotifications = [];
  workflowNotifications=[];
  questionsNotifications: Notification[] = [];
  documentRequestsNotifications: Notification[] = [];
  exportNotifications: Notification[] = [];
  notificationsTabs: NotificationsTabInterface[];
  public alert: string;
  public documentRequest: string;
  public myTask: string;
 
  @HostBinding("class.notification-menu")
  private readonly notificationMenu = true;

  constructor(
    private alertsNotificationsService: AlertsNotificationsService,
    private workflowNotificationService:WorkflowNotificationService,
    private nodeService: NodesService,
    private _notificationService: NotificationsService,
    private _notificationMenuService: NotificationMenuService,
    private cd: ChangeDetectorRef,
    protected userService: UserService,
    protected notificationSystemsRegistry: NotificationSystemsRegistryService,
    protected _documentRequestNotificationsService: DocumentRequestNotificationsService,

    private router: Router
  ) {
    this.alertsNotificationsService.initNotifications().subscribe(notifs => {
    
      this.alertsNotifications.push(notifs);
   
    });
this.workflowNotificationService.initNotifications().subscribe(notifs=>{
 
  this.workflowNotifications.push(notifs);

  for (var i = 0; i < this.workflowNotifications.length; i++) {
    if (this.workflowNotifications[i].domain !== 'export') {
      this.exportNotifications.splice(this.workflowNotifications.indexOf(this.workflowNotifications[i]), 1);
    }
  }

});
    this._documentRequestNotificationsService
      .initNotifications()
      .subscribe(notifs => {
        this.documentRequestsNotifications.push(notifs);
      });

    /*
     * TODO: Create a service for notification registration and management
     * */
    this.notificationSystemsRegistry.register(
      "Alerts",
      this.alertsNotificationsService
    );

    this.notificationSystemsRegistry.register(
      "workflow",
      this.alertsNotificationsService
    );

    this.notificationSystemsRegistry.register(
      "DocumentRequests",
      this._documentRequestNotificationsService
    );

    const lang = localStorage.getItem("lang")

    switch(lang){
      case "fr":
      this.alert = "Mes alertes"
      this.documentRequest = "Demandes de documents"
      this.myTask = "Mes tâches"
        break
      case "gb":
        this.alert = "My alerts"
        this.documentRequest = "Documents requests"
        this.myTask = "My tasks"
        break
    }
  
 
    this.notificationsTabs = [
      {
        header: this.alert,
        service: this.alertsNotificationsService,
        notifications: this.alertsNotifications,
        badge: new NotificationBadge(
          merge(
            this.alertsNotificationsService.initNotifications(),
            this.alertsNotificationsService.notifications$
          )
        )
      },
      {
        header: this.documentRequest,
        service: this._documentRequestNotificationsService,
        notifications: this.documentRequestsNotifications,
        badge: new NotificationBadge(
          merge(
            this._documentRequestNotificationsService.initNotifications(),
            this._documentRequestNotificationsService.notifications$
          ).pipe(filter(n => !n.seen))
        )
      },
      {
        header: this.myTask,
        service: this.workflowNotificationService,
        notifications: this.workflowNotifications,
        badge: new NotificationBadge(
          merge(
            this.workflowNotificationService.initNotifications(),
            //this.workflowNotificationService.notifications$
          )
        )
      }
    ];
   
  }

  private _configurationMode = false;

  get configurationMode(): boolean {
    return this._configurationMode;
  }

  set configurationMode(value: boolean) {
    this._configurationMode = value;
  }

  resetCount() {
    this._notificationMenuService.resetCount();
  }

  ngOnInit(): void {
    const toastConfiguration = {
      clickToClose: true
    };
   

    /*
     Todo: encapsulate the logic of sound configuration in the notification service
     */
    let questionHasToastNotification = false;
    let alertHasToastNotification = false;
    let exportHasToastNotification = false;
    let workflowHasToastNotification=true;


    this.alertsNotificationsService.configuration.getToast$().subscribe(on => {
      alertHasToastNotification = on;
    });
    this.workflowNotificationService.configuration.getToast$().subscribe(on => {
      workflowHasToastNotification = on;
    });

    this.alertsNotificationsService.notifications$.subscribe(
      (notification: { domain: string; content: AlertContentInterface }) => {
        this.alertsNotifications.unshift(notification);
        if (alertHasToastNotification) {
          this._notificationService.info(
            notification.domain,
            notification.content.description,
            toastConfiguration
          );
        }
      }
    );

    this.workflowNotificationService.notifications$.subscribe(
      (notification: { domain: string; content: WorkflowContentInterface }) => {
        this.workflowNotifications.unshift(notification);
        if (workflowHasToastNotification) {
          this._notificationService.info(
            notification.domain,
            notification.content.type,
            toastConfiguration
          );
        }
      }
    );

    this._documentRequestNotificationsService.notifications$.subscribe(
      notification => {
        this.documentRequestsNotifications.unshift(notification);
      }
    );
  }

  ngAfterViewInit(): void {
   
    /*setInterval(() => {
    
     this._documentRequestNotificationsService.triggerTest();
    
     }, 2000);*/
  }

  toggleConfigurationMode() {
    this.configurationMode = !this.configurationMode;
  }

  closeMenu(node: any) {
   
    if (node.domain === "alert") {
      const idFile = node.content.nodeRef.split("/");

    //  this.nodeService.resolveOne(idFile[3]).then(res => {
       
    //     if (res.isFile == true) {
    //      

    //       this.router.navigate([
    //         "/home/my-libraries/sites",
    //         SITE_NAME,
    //         "lib",
    //         res.parentId,
    //         "preview",
    //         idFile[3]
    //       ]);
    //     } else {
    //      

    //       this.router.navigate([
    //         "/home/my-libraries/sites",
    //         SITE_NAME,
    //         "lib",
    //         idFile[3]
    //       ]);
    //     }
    //  });


    this.router.navigate([
            "/home/alerts"
          ]);
    } else if (node.domain === "documentRequest") {
     
      const id=node.content.id;
      this.router.navigate(['/home/document-request',id]);
    }else if (node.domain ==="workflow"){
      
      this.router.navigate(['/home/tasks/see',node.content.id,node.content.processId]);
    
    }
  }

  public goToNotificationPage() {
    
    const routes = [
      "/home/alerts",
      "/home/document-request"
    ];

    this.router.navigate([routes[this.tabGroup.selectedIndex]]);
  }

  getNumberUnseenNotifications(notifications) {
    if (!notifications) {
      return 0;
    }

    let compteur = 0;

    for (let n of notifications) {
      if (!n.seen) {
        compteur++;
      }
    }

    return compteur;
    //return notifications.reduce((n, acc) => n.seen ? acc : acc + 1, 0);
  }
}
